module.exports = __webpack_public_path__ + "img/book-5.71506713.png";